import { alpha, makeStyles } from '@material-ui/core';

import { BANNER_PERFORMANCE_PREDICTIONS_HEIGHT, COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: '100%',
      minHeight: BANNER_PERFORMANCE_PREDICTIONS_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: COLORS.primary.active,
      padding: theme.spacing(0, 6, 0, 2),
    },
    text: {
      color: COLORS.neutral.white,
    },
    buttonUpgrade: {
      margin: theme.spacing(0, 2),
      padding: theme.spacing(1, 2),
      backgroundColor: COLORS.neutral.white,
      color: COLORS.primary.active,
      '&:hover': {
        color: COLORS.primary.active,
        backgroundColor: alpha(COLORS.neutral.white, 0.82),
      },
      '&:active': {
        backgroundColor: COLORS.neutral.white,
      },
    },
    buttonClose: {
      position: 'absolute',
      right: theme.spacing(2),

      '& svg': {
        fontSize: theme.typography.pxToRem(24),
        color: COLORS.neutral.white,
      },
    },
  }),
  {
    name: 'PerformancePredictionsBanner',
  }
);
